import { throttle } from 'lodash-es';
import { useEffect, useRef } from 'react';

export interface ScrollInfo {
  x: number;
  y: number;
}

export const useScrollPosition = (
  node: HTMLElement | null,
  effect?: (scrollInfo: ScrollInfo) => void,
  wait = 100
) => {
  const stateRef = useRef<ScrollInfo>({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const state = stateRef.current;

    if (node) {
      const onScroll = () => {
        if (state.y !== node.scrollTop) {
          const newState: ScrollInfo = {
            x: node.scrollLeft,
            y: node.scrollTop,
          };
          stateRef.current = newState;

          if (effect) {
            effect(newState);
          }
        }
      };

      node.addEventListener('scroll', throttle(onScroll, wait), {
        capture: false,
        passive: true,
      });

      return () => node.removeEventListener('scroll', onScroll);
    }
  }, [effect, node, wait]);

  return stateRef.current;
};
